import ExternalApiRequest from 'services/externalApiRequest';

const connector = () => {
    const options = {
        api: "refreshToken"
    };
    return ExternalApiRequest(options);
};

export default connector;
